import { useInfiniteTableItems } from "@/app/components/infinite-table/use-infinite-table-items"
import type { DropActivity } from "@anaconda/core/drop/types"
import { useInfiniteQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { useMemo } from "react"
import { DropActivityMoleculeReatom } from "./drop-activity-molecule.reatom"

export const useActivityItems = () => {
  const { dropActivityQueryParams } = useMolecule(DropActivityMoleculeReatom)
  const queryParams = dropActivityQueryParams()

  const dropActivityQuery = useInfiniteQuery(queryParams)

  const queryResult = useMemo(
    () => ({
      ...dropActivityQuery,
      pages:
        dropActivityQuery.data?.pages.map(
          (page: { activities: DropActivity[] }) => ({
            items: page.activities,
          }),
        ) ?? [],
    }),
    [dropActivityQuery],
  )

  return useInfiniteTableItems(queryResult)
}
